import { getManhattanDistance } from "utils/math/geometry/getManhattanDistance";
import { CalculatePathUtilization } from "./types";

export const calculatePathUtilization: CalculatePathUtilization = ({
  edgeCounts,
  nodes,
}) => {
  let totalLength = 0;
  let sharedLength = 0;

  for (const [edgeKey, count] of edgeCounts.entries()) {
    const [from, to] = edgeKey.split("|");
    if (!from || !to) continue;

    const nodeA = nodes[from];
    const nodeB = nodes[to];

    // Skip if coordinates are missing
    if (!nodeA || !nodeB) continue;

    const edgeLen = getManhattanDistance({
      pointA: { x: nodeA.x, y: nodeA.y },
      pointB: { x: nodeB.x, y: nodeB.y },
    });

    // Logic: total counts every edge once, shared counts only if used > 1 time
    totalLength += edgeLen;
    if (count > 1) {
      sharedLength += edgeLen;
    }
  }

  return { totalLength, sharedLength };
};
